import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="sp-footer">
      <div className="sp-footer-container">

        {/* Our Vision */}
        <div className="sp-footer-vision">
          <h3>Our Vision</h3>
          <p>
            To build innovative solutions that empower businesses and deliver
            measurable results.
          </p>
        </div>

        {/* Quick Links */}
        <div className="sp-footer-quick-links">
          <h3>Quick Links</h3>
          <ul>
  <li><Link to="/web-design-kenya/">Web Design in Kenya</Link></li>
  <li><Link to="/digital-marketing-smes/">Digital Marketing for SMEs</Link></li>
  <li><Link to="/social-media-management-services/">Social Media Marketing</Link></li>
  <li><Link to="/content-creation-services/">Content Creation</Link></li>
  <li><Link to="/digital-strategy-consultation/">Digital Strategy & Consultation</Link></li>
  <li><Link to="/corporate-training/">Corporate Training</Link></li>
  <li><Link to="/custom-software-solutions/">Custom Software Solutions</Link></li>
</ul>
        </div>

        {/* Contact Info */}
        <div className="sp-footer-contact">
          <h3>Contact</h3>
          <p>
            <FaWhatsapp />{" "}
            <a
              href="https://wa.me/254775137928"
              target="_blank"
              rel="noopener noreferrer"
            >
              +254 799 090 598
            </a>
          </p>
          <p>
            <FaEnvelope />{" "}
            <a href="mailto:info@satimatechnova.co.ke">
              info@satimatechnova.co.ke
            </a>
          </p>
          <p>
            <FaPhoneAlt />{" "}
            <a href="tel:+254799090598">+254 799 090 598</a>
          </p>
        </div>

        {/* Social Media */}
        <div className="sp-footer-social">
          <h3>Connect With Us</h3>
          <div className="sp-footer-social-icons">
            <a
              href="https://www.facebook.com/share/1ZEARUmfKZ/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/satimatechnovasolutions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/107933110/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="sp-footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Satima Technova Solutions. All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
